export const WIFI_TIMER_KEY = 'WIFI_TIMER_KEY'
